import { Table, TableBody, TableContainer, TableHead, TableRow } from '@mui/material';
import { ActionTableColumnsType } from '../../../../../types/table/ActionTableColumnsType';
import { ActionTableSortParamsType } from '../../../../../types/table/ActionTableSortParamsType';
import TableColumns from '../TableColumns';
import styles from './styles.module.scss';

type StyledTableleProps = {
  columns: ActionTableColumnsType[];
  rows: React.ReactNode;
  sortParams?: ActionTableSortParamsType;
  onClickHeader?: (column: string) => void;
};

export const TableRoot: React.FC<StyledTableleProps> = ({
  columns,
  rows,
  sortParams,
  onClickHeader,
}) => {
  return (
    <TableContainer className={styles.tableContainer}>
      <Table stickyHeader aria-label='simple table' className={styles.tableContent}>
        <TableHead>
          <TableRow>
            <TableColumns columns={columns} onClickHeader={onClickHeader} sortParams={sortParams} />
          </TableRow>
        </TableHead>
        <TableBody>{rows}</TableBody>
      </Table>
    </TableContainer>
  );
};
